export default __webpack_public_path__ + "static/media/direct-payment-finder-japan.bbe6a186.gif";